// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../graphql/api/index';

export const EngagementRingLinkFragmentDoc = `
    fragment engagementRingLink on CatalogueEngagementRing {
  __typename
  catalogueCode
  primaryMetal {
    systemCode
  }
  centreStoneConstraints {
    shape {
      systemCode
    }
  }
  suffixSlug
  slug
  grande {
    catalogueCode
  }
  nonGrande {
    catalogueCode
  }
}
    `;